import Icon from "@ant-design/icons";

const Component = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.4714 4.86177C10.7318 5.12212 10.7318 5.54423 10.4714 5.80457L5.13807 11.1379C4.87772 11.3983 4.45561 11.3983 4.19526 11.1379C3.93491 10.8776 3.93491 10.4554 4.19526 10.1951L9.5286 4.86177C9.78895 4.60142 10.2111 4.60142 10.4714 4.86177Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 5.33317C4.81591 5.33317 4.66667 5.48241 4.66667 5.6665C4.66667 5.8506 4.81591 5.99984 5 5.99984C5.18409 5.99984 5.33333 5.8506 5.33333 5.6665C5.33333 5.48241 5.18409 5.33317 5 5.33317ZM3.33333 5.6665C3.33333 4.74603 4.07953 3.99984 5 3.99984C5.92047 3.99984 6.66667 4.74603 6.66667 5.6665C6.66667 6.58698 5.92047 7.33317 5 7.33317C4.07953 7.33317 3.33333 6.58698 3.33333 5.6665Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.66667 9.99984C9.48257 9.99984 9.33333 10.1491 9.33333 10.3332C9.33333 10.5173 9.48257 10.6665 9.66667 10.6665C9.85076 10.6665 10 10.5173 10 10.3332C10 10.1491 9.85076 9.99984 9.66667 9.99984ZM8 10.3332C8 9.4127 8.74619 8.6665 9.66667 8.6665C10.5871 8.6665 11.3333 9.4127 11.3333 10.3332C11.3333 11.2536 10.5871 11.9998 9.66667 11.9998C8.74619 11.9998 8 11.2536 8 10.3332Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.33333 1.99984C4.01962 1.99984 1.33333 4.68613 1.33333 7.99984C1.33333 11.3135 4.01962 13.9998 7.33333 13.9998C7.74516 13.9998 8.14664 13.9584 8.53405 13.8798C8.89488 13.8066 9.24676 14.0397 9.32001 14.4005C9.39325 14.7614 9.16012 15.1132 8.79929 15.1865C8.32507 15.2828 7.83475 15.3332 7.33333 15.3332C3.28325 15.3332 0 12.0499 0 7.99984C0 3.94975 3.28325 0.666504 7.33333 0.666504C11.3834 0.666504 14.6667 3.94975 14.6667 7.99984C14.6667 8.58483 14.598 9.15465 14.4681 9.70137C14.383 10.0596 14.0236 10.2809 13.6653 10.1958C13.3071 10.1107 13.0858 9.75126 13.1709 9.39305C13.277 8.94661 13.3333 8.48024 13.3333 7.99984C13.3333 4.68613 10.647 1.99984 7.33333 1.99984Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.8047 11.5284C16.0651 11.7888 16.0651 12.2109 15.8047 12.4712L12.8047 15.4712C12.5444 15.7316 12.1223 15.7316 11.8619 15.4712L10.5286 14.1379C10.2682 13.8776 10.2682 13.4554 10.5286 13.1951C10.7889 12.9347 11.2111 12.9347 11.4714 13.1951L12.3333 14.057L14.8619 11.5284C15.1223 11.2681 15.5444 11.2681 15.8047 11.5284Z"
      fill="currentColor"
    />
  </svg>
);

export const CommissionApprovalIcon = (props) => (
  <Icon component={Component} {...props} />
);
